import { Component, OnInit, ViewChild } from '@angular/core';
import { ITeam } from 'src/app/models/team';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { Router } from '@angular/router';
import { TeamsService } from 'src/app/services/teams.service';
import { FolioHelperService } from 'src/app/utilities/folio-helper.service';
import { LabelConstants, AppConstants } from 'src/app/utilities/app-constants';
import { FolioDialogModel } from 'src/app/modules/shared/folio-dialog-component/folio-dialog.component';
import { FolioDialogService } from 'src/app/modules/shared/folio-dialog-component/folio-dialog.service';
import * as AWS from 'aws-sdk';
// import S3 from 'aws-sdk/clients/s3';

@Component({
  selector: 'app-teams',
  templateUrl: './teams.component.html',
  styleUrls: ['./teams.component.css']
})
export class TeamsComponent implements OnInit {
  readonly MY_CONSTANT = LabelConstants;

  teams: ITeam[] = [];
  displayedColumns: string[] = ['TEAM_ID', 'TEAM_NAME', 'TEAM_LEAD', 'view', 'delete'];
  dataSource;
  selection = new SelectionModel<ITeam>(true, []);
  showTable = false;
  showTableDataLabel = this.MY_CONSTANT.LABEL_FETCHING;
  charLimit = AppConstants.PARAM_CHAR_LIMIT_SHORT_TEXT;

  @ViewChild(MatTable, { static: true }) table: MatTable<any>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private teamsService: TeamsService,
    private folioHelperService: FolioHelperService,
    private router: Router,
    private matSnackBar: MatSnackBar,
    public dialog: MatDialog,
    private folioDialogService: FolioDialogService,
  ) { }

  ngOnInit() {

    this.dataSource = new MatTableDataSource();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.folioHelperService.setSpinnerVisible(true);
    this.teamsService.getAllTeamsQuery().then((sucs) => {
      const teams = JSON.parse(sucs.data['listTeams'].data)[0];
      this.logTeam(teams);
    }).catch((err) => {
      this.folioHelperService.setSpinnerVisible(false);
      this.showTableDataLabel = this.MY_CONSTANT.LABEL_TEAMS_UNABLE_TO_FETCH;
      this.showTable = false;
      this.matSnackBar.open(this.MY_CONSTANT.LABEL_ERROR_TRY_AGAIN, null, {
        duration: 3000
      });
      console.log('Error all teams', err);
      this.folioHelperService.setSpinnerVisible(false);
    });

  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach((row: ITeam) => this.selection.select(row));
  }

  logTeam(team: ITeam[]): any {
    if (team.length <= 0) {
      this.showTableDataLabel = this.MY_CONSTANT.LABEL_TEAMS_NOT_AVAILABLE;
      this.folioHelperService.setSpinnerVisible(false);
      return;
    }
    this.teams = team as ITeam[];
    this.dataSource.data = this.teams;
    // setTimeout(() => {
    this.showTable = true;
    this.folioHelperService.setSpinnerVisible(false);
    // }, 2000);
  }

  addNewPermitClick() {
    this.router.navigate([`/${AppConstants.PARAM_ROUTE_VALUE_ADD_TEAM}`]);
  } // Add new permit

  navigateToFormWithID(team: ITeam) {
    this.router.navigate([`/${AppConstants.PARAM_ROUTE_VALUE_ADD_TEAM}`, team.TEAM_ID]);
  }

  deleteRecord(team: ITeam) {

    const dialogData: FolioDialogModel = {
      titleString: `${this.MY_CONSTANT.LABEL_TEAMS_CONFIRM_DELETE} : ${team.TEAM_NAME} ?`,
      okButtonString: this.MY_CONSTANT.LABEL_COOL_DIALOG_OK_BUTTON,
    };

    this.folioDialogService.confirm(dialogData).afterClosed().subscribe(result => {
      if (result === undefined) {
        return;
      }
      if (result) {
        this.deleteRecordHelper(team);
      } else {
        console.log('Cancel clicked');
      }
    });

  }

  deleteRecordHelper(team: ITeam) {
    try {
      this.folioHelperService.setSpinnerVisible(true);
      this.teamsService.deleteTeamMutation(team.TEAM_ID).then(
        () => {
          this.removeDataFromTable(team.TEAM_ID);
          this.folioHelperService.setSpinnerVisible(false);
        }
      ).catch(
        () => {
          this.folioHelperService.setSpinnerVisible(false);
          this.matSnackBar.open(this.MY_CONSTANT.LABEL_ERROR_TRY_AGAIN, null, { duration: 3000 });
        }
      );
    } catch (error) {
      this.folioHelperService.setSpinnerVisible(false);
      this.matSnackBar.open(this.MY_CONSTANT.LABEL_ERROR_TRY_AGAIN, null, { duration: 3000 });
    }
  }

  removeDataFromTable(teamId: string): any {
    this.teams = this.teams.filter((team) => {
      return team.TEAM_ID !== teamId;
    });
    this.dataSource.data = this.teams;
    this.table.renderRows();
  }

}
